import { PlaceResource } from '../resources/resource';
export var AuthType;
(function (AuthType) {
    AuthType[AuthType["Certificate"] = 0] = "Certificate";
    AuthType[AuthType["NoAuth"] = 1] = "NoAuth";
    AuthType[AuthType["UserPassword"] = 2] = "UserPassword";
})(AuthType || (AuthType = {}));
export class PlaceMQTTBroker extends PlaceResource {
    constructor(data = {}) {
        super();
        this.auth_type = data.auth_type || AuthType.UserPassword;
        this.description = data.description || '';
        this.host = data.host || '';
        this.port = data.port || 1883;
        this.tls = data.tls || false;
        this.username = data.username || '';
        this.password = data.password || '';
        this.certificate = data.certificate || '';
        this.secret = data.secret || '';
        this.filters = data.filters || [];
    }
}
